import { UtilService } from 'app/_services/util.service';
import { Growl } from 'angular/custom/services/growl.service';
import { ErrorHandler } from 'app/_services/error-handler.factory';
import { TransmissionSystemOperatorResource } from 'app/_resources/transmission-system-operator.resource';
import * as angular from 'angular';

class TransactionTypeSettingsComponentCtrl implements ng.IController {
    private settings: TsoSecondarySettingsDto;
    private authenticatedUser: LoginResult;
    private enableLeadTimes: boolean;
    private leadPanelExpanded: boolean;

    constructor(
        private utilService: UtilService,
        private growl: Growl,
        private errorHandler: ErrorHandler,
        private TransmissionSystemOperator: TransmissionSystemOperatorResource
    ) {}

    $onInit() {}

    public saveTransactionTypeSupport(clickedTransactionType: string) {
        const selectedTransactionTypes = this.utilService
            .values<boolean>(this.settings.transactionTypeSupport)
            .filter((t) => t);

        if (!selectedTransactionTypes.length) {
            this.settings.transactionTypeSupport[clickedTransactionType] = true;
            this.growl.show(
                'Please select at least one transaction type.',
                'danger'
            );
        } else {
            //if a transaction type is disabled also disable the automatic approval
            if (!this.settings.transactionTypeSupport[clickedTransactionType]) {
                if (angular.equals(clickedTransactionType, 'ASSIGNMENT')) {
                    this.settings.enableAutomaticApprovalOfTradesForAssignment =
                        false;
                    this.saveAutomaticApprovalOfTradesForAssignment(true);
                } else if (
                    angular.equals(clickedTransactionType, 'TRANSFER_OF_USE')
                ) {
                    this.settings.enableAutomaticApprovalOfTradesForTransferOfUse =
                        false;
                    this.saveAutomaticApprovalOfTradesForTransferOfUse(true);
                }
            }
            this.TransmissionSystemOperator.saveSecondaryTransactionTypeSupport(
                { id: this.authenticatedUser.referenceId },
                this.settings.transactionTypeSupport,
                () => {
                    this.growl.show('Successfully saved.', 'success', {
                        delay: 2000
                    });
                },
                this.errorHandler
            );
        }
    }

    public saveAutomaticApprovalOfTradesForAssignment(silentGrowl: boolean) {
        this.TransmissionSystemOperator.saveAutomaticApprovalOfTradesForAssignment(
            { id: this.authenticatedUser.referenceId },
            this.settings.enableAutomaticApprovalOfTradesForAssignment,
            () => {
                if (!silentGrowl)
                    this.growl.show('Successfully saved.', 'success', {
                        delay: 2000
                    });
            },
            this.errorHandler
        );
    }

    public saveAutomaticApprovalOfTradesForTransferOfUse(silentGrowl: boolean) {
        this.TransmissionSystemOperator.saveAutomaticApprovalOfTradesForTransferOfUse(
            { id: this.authenticatedUser.referenceId },
            this.settings.enableAutomaticApprovalOfTradesForTransferOfUse,
            () => {
                if (!silentGrowl)
                    this.growl.show('Successfully saved.', 'success', {
                        delay: 2000
                    });
            },
            this.errorHandler
        );
    }

    public scrollToAnchor(anchorId: string) {
        this.leadPanelExpanded = true;
        //TODO make sure that enableLeadTimes does not remain activated,
        //TODO if after scrolling to that section, no configuration change is persisted
        if (anchorId === 'configure-lead-time') {
            this.enableLeadTimes = true;
        }
        this.utilService.scrollToAnchor(anchorId, 800, 80, 500);
    }
}

angular.module('app').component('pkpTransactionTypeSettings', {
    controller: TransactionTypeSettingsComponentCtrl,
    template:
        require('app/operator-settings-secondary-market/transaction-type-settings.component.html'),
    bindings: {
        settings: '=',
        authenticatedUser: '=',
        enableLeadTimes: '=',
        leadPanelExpanded: '='
    }
});
